/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var MOJIBAKE_SELECTOR = [
    '.product-item__title',
    '.product-item__title-link',
    '.product-card__title',
    '.grid-product__title',
    '.card__heading',
    '.tcb-plp-card__title',
    '.tcb-plp-card__title a',
    '.product-meta__title',
    '.product-meta__title a',
    'h1.product-title',
    '.tcb-buy-box h1',
    '.product-item-meta__title',
    '.tcb-home-categories__title',
    '.featured-collection .product-item__title',
    '.section--featured-collection .product-item__title',
    '[data-section-type="featured-collection"] .product-item__title',
    '[data-section-type="tcb-collection-page"] .tcb-plp-card__title a',
    'a[href*="/products/"].link',
    '.tcb-tab-body',
    '.tcb-pdp-overview',
    '.tcb-product-description',
    '.product-form__description',
    '.rte'
  ].join(', ');

  function needsMojibakeFix(text) {
    return text && (text.indexOf('â€') > -1 || text.indexOf('Ã') > -1 || text.indexOf('Â') > -1 || text.indexOf('\uFFFD') > -1);
  }

  function normalizeMojibakeText(text) {
    if (!text) return text;
    return String(text)
      .replace(/\uFFFD/g, '—')
      .replace(/3\s*\u00e2\u20ac[\u201c\u201d]\s*8/gi, '3 to 8')
      .replace(/3\s*\u00e2\u20ac[\u201c\u201d]8/gi, '3 to 8')
      .replace(/\u00e2\u20ac\u201d/g, '—')
      .replace(/\u00e2\u20ac\u201c/g, '–')
      .replace(/3\s*â€[\x93\x94\u201c\u201d]\s*8/gi, '3 to 8')
      .replace(/3\s*â€[\x93\x94\u201c\u201d]8/gi, '3 to 8')
      .replace(/â€[\x93\x94\u201d]/g, '—')
      .replace(/â€[\x93\x94\u201c]/g, '–')
      .replace(/\u00e2\u20ac\u2122/g, "'")
      .replace(/â€™/g, "'")
      .replace(/\u00e2\u20ac\u2018/g, "'")
      .replace(/â€˜/g, "'")
      .replace(/\u00e2\u20ac\u0153/g, '"')
      .replace(/â€œ/g, '"')
      .replace(/â€[\x9d]/g, '"')
      .replace(/\u00e2\u20ac\u00a6/g, '…')
      .replace(/â€¦/g, '…')
      .replace(/\u00e2\u20ac\u00a2/g, '•')
      .replace(/â€¢/g, '•')
      .replace(/\u00e2\u2044\u2122/g, '™')
      .replace(/â„¢/g, '™')
      .replace(/Â°/g, '°')
      .replace(/Â®/g, '®')
      .replace(/Â©/g, '©')
      .replace(/Ã©/g, 'é')
      .replace(/Ã¨/g, 'è')
      .replace(/Ãª/g, 'ê')
      .replace(/Ã /g, 'à')
      .replace(/Ã¢/g, 'â')
      .replace(/Ã®/g, 'î')
      .replace(/Ã´/g, 'ô')
      .replace(/Ã»/g, 'û')
      .replace(/Ã¼/g, 'ü')
      .replace(/Ã±/g, 'ñ')
      .replace(/Ã—/g, '×')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function fixMojibakeText(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(MOJIBAKE_SELECTOR).forEach(function (el) {
      var text = (el.innerText || el.textContent || '').trim();
      if (needsMojibakeFix(text)) {
        el.textContent = normalizeMojibakeText(text);
      }
    });
  }

  function runFixes() {
    fixMojibakeText(document);
  }

  function shouldObserveDynamicCards() {
    var pageType = window.theme && window.theme.pageType;
    return pageType === 'index' || pageType === 'collection' || pageType === 'page' || pageType === 'search';
  }

  function startDynamicObserver() {
    if (!('MutationObserver' in window) || !shouldObserveDynamicCards()) return;

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (!hasNewNodes || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        fixMojibakeText(document);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    runFixes();
    startDynamicObserver();
    fixNotFoundPage();
  });

  [400, 1500].forEach(function (ms) {
    window.setTimeout(runFixes, ms);
    window.setTimeout(fixNotFoundPage, ms);
  });

  function fixNotFoundPage() {
    var root = document.querySelector('.tcb-not-found');
    if (!root || root.dataset.tcb404Layout === '1') return;
    root.dataset.tcb404Layout = '1';
    root.style.display = 'flex';
    root.style.alignItems = 'center';
    root.style.justifyContent = 'center';
    root.style.textAlign = 'center';
    root.style.minHeight = 'clamp(420px, 62vh, 720px)';
    root.style.padding = 'clamp(32px, 6vw, 72px) 20px';

    var grid = root.querySelector('.tcb-not-found__grid');
    if (grid) {
      grid.style.display = 'flex';
      grid.style.flexDirection = 'column';
      grid.style.alignItems = 'center';
      grid.style.gap = '32px';
      grid.style.width = '100%';
      grid.style.maxWidth = '760px';
      grid.style.margin = '0 auto';
    }

    var copy = root.querySelector('.tcb-not-found__copy');
    if (copy) copy.style.textAlign = 'center';

    var actions = root.querySelector('.tcb-not-found__actions');
    if (actions) actions.style.justifyContent = 'center';

    var media = root.querySelector('.tcb-not-found__media');
    if (media) {
      media.style.width = '100%';
      media.style.maxWidth = '640px';
      if (grid && media !== grid.firstElementChild) grid.insertBefore(media, grid.firstElementChild);
    }

    var frame = root.querySelector('.tcb-not-found__frame');
    if (frame) {
      frame.style.minHeight = '320px';
      frame.style.background =
        '#fff url(https://thecleaningbusiness.com/cdn/shop/t/9/assets/tcb-mega-promo-equipment.jpg) center/contain no-repeat';
      frame.style.borderRadius = '16px';
      frame.style.overflow = 'hidden';
      frame.style.boxShadow = '0 18px 48px rgba(16, 35, 63, 0.12)';
      frame.style.border = '1px solid rgba(16, 35, 63, 0.08)';
    }

    var img = root.querySelector('.tcb-not-found__img');
    if (!img) return;
    var fallback = 'https://thecleaningbusiness.com/cdn/shop/t/9/assets/tcb-mega-promo-equipment.jpg';
    function applyFallback() {
      if (img.dataset.tcb404Img === '1') return;
      img.dataset.tcb404Img = '1';
      img.removeAttribute('srcset');
      img.src = fallback;
      img.style.display = 'block';
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.objectFit = 'contain';
    }
    if (!img.complete || img.naturalWidth === 0) applyFallback();
    img.addEventListener('error', applyFallback);
  }

  window.tcbNormalizeMojibakeText = normalizeMojibakeText;
  window.tcbFixNotFoundPage = fixNotFoundPage;
})();
